// src/types/bookings/SlotHold.ts
var SlotHoldRefusalCode = /* @__PURE__ */ ((SlotHoldRefusalCode2) => {
  SlotHoldRefusalCode2["RunEmpty"] = "SLOT_RUN_EMPTY";
  SlotHoldRefusalCode2["RunIncomplete"] = "SLOT_RUN_INCOMPLETE";
  SlotHoldRefusalCode2["RunNotContiguous"] = "SLOT_RUN_NOT_CONTIGUOUS";
  SlotHoldRefusalCode2["RunCancelled"] = "SLOT_RUN_CANCELLED";
  SlotHoldRefusalCode2["GroupSize"] = "SLOT_GROUP_SIZE";
  SlotHoldRefusalCode2["ListingKindUnsupported"] = "LISTING_KIND_UNSUPPORTED";
  SlotHoldRefusalCode2["ListingNotFound"] = "LISTING_NOT_FOUND";
  SlotHoldRefusalCode2["SlotNotFound"] = "SLOT_NOT_FOUND";
  return SlotHoldRefusalCode2;
})(SlotHoldRefusalCode || {});
var SLOT_QUOTE_UNAVAILABLE = "SLOT_QUOTE_UNAVAILABLE";
var InventoryKindRefusal = /* @__PURE__ */ ((InventoryKindRefusal2) => {
  InventoryKindRefusal2["Modification"] = "MODIFICATION_UNSUPPORTED_FOR_KIND";
  InventoryKindRefusal2["UnitChange"] = "UNIT_CHANGE_UNSUPPORTED_FOR_KIND";
  InventoryKindRefusal2["Invitation"] = "INVITATION_UNSUPPORTED_FOR_KIND";
  InventoryKindRefusal2["GuestDocuments"] = "GUEST_DOCUMENTS_UNSUPPORTED_FOR_KIND";
  InventoryKindRefusal2["Checkout"] = "CHECKOUT_UNSUPPORTED_FOR_KIND";
  InventoryKindRefusal2["StayConfirmation"] = "STAY_CONFIRMATION_UNSUPPORTED_FOR_KIND";
  return InventoryKindRefusal2;
})(InventoryKindRefusal || {});

export {
  SlotHoldRefusalCode,
  SLOT_QUOTE_UNAVAILABLE,
  InventoryKindRefusal
};
